export enum ELandingStepsAnimationDelay {
  TITLE = 0,
  ILLUSTRATION = 500,
  STEPS = 1000,
}
